import { Component } from '@angular/core';
import { HostListener } from '@angular/core';
import { SessionService } from './Services/session.service';
import { isNull } from 'util';


@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent {
 

  UAT_IP_1 = 'http://169.38.100.202:9245/#/'
  UAT_IP_2 = 'http://169.38.100.202:9246/#/'
  PROD_IP_1 = 'http://169.38.100.206:9254/#/'
  localHost = 'http://localhost:4200'
  title = 'MC Material Tracking';
  constructor(private session: SessionService) { }

  @HostListener('document:keyup', ['$event'])
  @HostListener('document:click', ['$event'])
  @HostListener('document:wheel', ['$event'])
  @HostListener('mousemove', ['$event'])
  @HostListener('window:scroll', ['$event'])
  onclick() {
  
    if ((window.location.href !== this.UAT_IP_1 + "MCMaterial/Login")
    && (window.location.href !== this.UAT_IP_2 + "MCMaterial/Login")  
    && (window.location.href !== this.PROD_IP_1 + "MCMaterial/Login")
    && (window.location.href !== this.localHost + "MCMaterial/Login")
    ) {
      this.session.resetSession();
    }
  }
}
